import { createContext } from "react";

interface Author {
    id: number;
    uuid: string;
    name: string;
    group: {
        title: string;
        icon: string;
    };
    rank: any;
    avatar: string;
    credits: number;
    signature: string;
    is_friend: boolean;
    total_distance: number;
    threads: {
        tid: number;
        subject: string;
        dateline: number;
        author_id: number;
    }[];
    devices: any[];
}

interface ForumTypes {
    fid: number;
    forum_name: string;
    type_id: number;
    name: string;
    level: number;
}

interface Message {
    type: number;
    imgsrc: string;
    key: string;
    url: string;
    desc: string;
}

export interface IThreadDetailCtx {
    tid: number;
    fid: number;
    posttableid: number;
    typeid: number;
    type_name: string;
    sortid: number;
    readperm: number;
    author: Author;
    authorid: number;
    subject: string;
    summary: string;
    message: Message[];
    dateline: number;
    lastpost: number;
    lastposter: string;
    views: number;
    replies: number;
    displayorder: number;
    highlight: number;
    digest: number;
    rate: number;
    special: number;
    attachment: number;
    moderated: number;
    closed: number;
    stickreply: number;
    recommends: number;
    heats: number;
    status: number;
    isgroup: number;
    favtimes: number;
    sharetimes: number;
    stamp: number;
    icon: number;
    pushedaid: number;
    cover: number;
    replycredit: number;
    comments: number;
    praise: number;
    floor: number;
    praised: boolean;
    favorite: boolean;
    platform: number;
    devices: any[];
    forum_types: ForumTypes[];
}

/** 承载帖子详情的全局数据 */
export const ThreadDetailCtx = createContext<IThreadDetailCtx | null>(null);